import React, { useEffect, useState } from 'react';
import Logo from './Logo';

interface SplashScreenProps {
  onComplete: () => void;
  minDuration?: number;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ 
  onComplete, 
  minDuration = 2000 
}) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out 300ms before completion for smooth transition
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, minDuration - 300);

    const completeTimer = setTimeout(() => {
      onComplete();
    }, minDuration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [minDuration, onComplete]);

  return (
    <div 
      className={`fixed inset-0 flex flex-col items-center justify-center z-50 transition-opacity duration-300 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{
        background: 'linear-gradient(135deg, #00BFA5 0%, #002C3E 100%)',
        fontFamily: "'Poppins', sans-serif"
      }}
    >
      {/* Logo drops from top with glow */}
      <div 
        className="mb-6 relative"
        style={{
          animation: 'dropBounce 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
          opacity: 0
        }}
      >
        <div className="absolute inset-0 blur-xl bg-primary/30 animate-pulse" />
        <Logo size="xl" className="w-32 h-32 relative z-10" />
      </div>
      
      {/* Cross Smart - slides from left */}
      <h1 
        className="text-white text-3xl font-semibold"
        style={{
          animation: 'slideFromLeft 1s ease-in-out forwards',
          opacity: 0
        }}
      >
        Cross Smart
      </h1>
      
      {/* Cruza Tranquilo - slides from right */}
      <p 
        className="text-[#00BFA5] text-2xl font-semibold mt-2"
        style={{
          animation: 'slideFromRight 1s ease-in-out 0.4s forwards',
          opacity: 0
        }}
      >
        Cruza Tranquilo
      </p>

      <style>{`
        @keyframes dropBounce {
          0% {
            transform: translateY(-200px);
            opacity: 0;
          }
          60% {
            transform: translateY(10px);
            opacity: 1;
          }
          80% {
            transform: translateY(-5px);
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideFromLeft {
          0% {
            transform: translateX(-100vw);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideFromRight {
          0% {
            transform: translateX(100vw);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};
